import { Component, OnInit } from '@angular/core';

import { OnboardingProvider } from 'src/providers/onboarding/onboarding.provider';
import { Communication } from 'src/providers/communication/communication';
import { Me } from 'src/providers/me/me';
import { Card } from 'src/providers/card/card';

import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { WindowService } from 'src/shared/providers/window.service';
import { Util } from 'src/shared/util/util';
import { OnboardingComponent } from 'src/shared/components/onboarding/onboarding';
import { NotifyProsOfChangeOnboarding } from '../notify-pros-of-change-onboarding/notify-pros-of-change-onboarding';
import { AuthModalService } from 'src/shared/services/auth-modal.service';

@Component({
  selector: 'enable-guest-smart-number-onboarding',
  templateUrl: './enable-guest-smart-number-onboarding.html',
  styleUrls: ['./enable-guest-smart-number-onboarding.scss'],
  standalone: false
})
export class EnableGuestSmartNumberOnboarding implements OnInit {
  enableProSmartNumber = false;
  enableGuestSmartNumber = false;
  boundSave = this.save.bind(this);
  hasValidCard = false;
  isGuestAccount = false;
  isLoading = false;

  constructor(
    public onboardingProvider: OnboardingProvider,
    private communication: Communication,
    private me: Me,
    private rightSidePanelService: RightSidePanelService,
    private storage: TidyStorage,
    public windowService: WindowService,
    private util: Util,
    private card: Card,
    private authModalService: AuthModalService
  ) {}

  async ngOnInit() {
    this.isLoading = true;
    this.rightSidePanelService.setDialogPageTitle('Add Smart Number');
    this.isGuestAccount = await this.storage.retrieve('isGuestAccount') || false;
    this.hasValidCard = await this.card.hasValidCard();
    this.isLoading = false;
  }

  async save() {
    try {
      if (this.enableProSmartNumber || this.enableGuestSmartNumber) {
        const subscriptionTypes = await this.me.getSubscriptionTypes();
        const hasNonTrialPaidSubscription = await this.me.checkIfHasNonTrialPaidSubscription(subscriptionTypes);
        if (!hasNonTrialPaidSubscription) {
          this.util.showError('You must be on a paid subscription to create smart numbers.');
          return this.rightSidePanelService.navigateTo('subscription', {});
        }
      }

      const promises: Promise<any>[] = [];

      if (this.enableProSmartNumber) {
        promises.push(this.communication.createProxyNumber('homekeeper'));
      }
      if (this.enableGuestSmartNumber) {
        promises.push(this.communication.createProxyNumber('guest'));
      }

      await Promise.all(promises);

      await this.onboardingProvider.markGoalAsCompleted('enableGuestSmartNumber');

      this.util.showSuccess('Settings saved successfully');

      // Check if we need to redirect back to notify pros step
      const dialogParams = await this.storage.retrieve('dialog-params');
      if (dialogParams?.redirectAfterSmartNumber === 'notifyProsOfChange') {
        await this.storage.delete('dialog-params');
        this.rightSidePanelService.setDialogPageTitle('Notify Pros');
        this.rightSidePanelService.navigateTo('onboarding/notifyProsOfChange', {}, NotifyProsOfChangeOnboarding);
      } else {
        this.rightSidePanelService.setDialogPageTitle('Getting Started');
        this.rightSidePanelService.navigateTo('onboarding', {}, OnboardingComponent);
      }
      this.onboardingProvider.setShowOnboardingInHeader(true);
    } catch (error) {
      const errorMessage = error?.error?.message || 'Error creating smart numbers';
      this.util.showError(errorMessage);
    }
  }

  goToAddPaymentMethod(): void {
    this.rightSidePanelService.navigateTo('payment-methods/payment-method-form', {
      backPage: 'onboarding'
    });
  }

  openCompleteSignup(): void {
    this.authModalService.openAuthModal('auth', 'signup');
  }
}
